
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kSspz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1e5b138ce321a2e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $1e5b138ce321a2e1$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "Reaktion hinzuf\xfcgen",
    'fabric.reactions.error.unexpected': "Reaktionen sind vor\xfcbergehend nicht verf\xfcgbar.",
    'fabric.reactions.loading': 'Wird geladen...',
    'fabric.reactions.more.emojis': 'Mehr Emojis',
    'fabric.reactions.other.reacted.users': "{count, plural, one {und ein weiterer} other {und {count}\xa0weitere}}",
    'fabric.reactions.reactwithemoji': 'Mit {emoji}-Emoji reagieren',
    'fabric.reactions.summary': 'Alle Benutzerreaktionen anzeigen',
    'reaction-picker-trigger.add.reaction.message': "Eine Reaktion hinzuf\xfcgen",
    'reactions.dialog.close': "Schlie\xdfen",
    'reactions.dialog.left.navigate': 'Nach links navigieren',
    'reactions.dialog.reactions.count': "{count, plural, one {{count,number}\xa0Reaktion insgesamt} other {{count,number}\xa0Reaktionen insgesamt}}",
    'reactions.dialog.right.navigate': 'Nach rechts navigieren',
    'reactions.dialog.viewall': 'Alle anzeigen',
    'reactions.dialog.viewall.tooltip': 'Alle Benutzerreaktionen anzeigen'
};

});


//# sourceMappingURL=de.f13e7f5a.js.map
